import { Account } from '@/domain/usecases'
import { i18nTranslationHelper } from '@/i18n'

export namespace AccountType {
  const t = i18nTranslationHelper.getTEnums
  export class Enum {
    static readonly ANONYMOUS = new Enum(
      'ANONYMOUS',
      t('accountType.ANONYMOUS.title'),
      t('accountType.ANONYMOUS.label')
    )
    static readonly COLLABORATOR = new Enum(
      'COLLABORATOR',
      t('accountType.COLLABORATOR.title'),
      t('accountType.COLLABORATOR.label')
    )
    static readonly DEPENDENT = new Enum(
      'DEPENDENT',
      t('accountType.DEPENDENT.title'),
      t('accountType.DEPENDENT.label')
    )

    private constructor(
      public readonly name: string,
      public readonly title: string,
      public readonly label: string
    ) {}

    public is(accountProfile: Account.Model): boolean {
      return accountProfile.accountType === this
    }
  }

  export const findByName = (name: string): AccountType.Enum | undefined => {
    return Object.values(AccountType.Enum).find(t => t.name === name)
  }

  export const contains = (type: AccountType.Enum, types: AccountType.Enum[]): boolean => {
    return Object.values(types).some(t => t != null && t.name === type.name)
  }
}
